import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormGroup } from '@angular/forms';
import { OptionCard } from '../../../../interfaces/optionCard.interface';

@Component({
	selector: 'app-pymes-seleccion',
	standalone: true,
	imports: [CommonModule, TranslateModule],
	templateUrl: './pymes-seleccion.component.html',
	styleUrls: ['./pymes-seleccion.component.scss']
})
export class PymesSeleccionComponent {

	@Input() coverageOptions: OptionCard[];
	@Input() ageOptions: OptionCard[];
	@Input() medicalOptions: OptionCard[];
	// @Input() selectedCoverage: any;
	@Input() selectedMedicalOption: any;
	@Input() selectedAgeOption: any;
	@Input() seleccionada: boolean = false;
	@Input({ required: true }) form!: FormGroup;
	medicalOption = null;

	// @Output() medicalOptionSelected = new EventEmitter<string>();
	// @Output() withoutHospitalization = new EventEmitter<boolean>();

	titleCoverage: string = null;


	trackByOptionId(_: number, option: OptionCard): string {
		return option.id;
	}

	selectCoverage(id: string): void {
		this.form.get('coverage').setValue(id);
		// this.selectedCoverage = id;
	}

	selectMedicalOption(id: string): void {
		this.form.get('medical').setValue(id);
		this.selectedMedicalOption = id;
	}

	selectAgeOption(id: string): void {
		this.form.get('age').setValue(id);
		this.selectedAgeOption = id;
	}

	// checkAgeOptions(): boolean {
	// 	return this.selectedCoverage === 'con-hospitalizacion' &&
	// 		this.selectedMedicalOption === 'cuadro-medico-concertado';
	// }

	// checkHospitalicacion() {
	// 	return this.selectedCoverage !== 'sin-hospitalizacion'
	// }

	volverADatos() {
		console.log('volver');
	}

	guardarProyecto(): void {
		console.log('guardando')
	}
}
